"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepsCard = void 0;
const react_1 = __importDefault(require("react"));
const step1_svg_1 = __importDefault(require("../../assets/images/step1.svg"));
require("./steps-card.css");
const colorDefault = "#5c0f8b";
;
/**
 * Main component.
 * @name StepsCard
 * @param {StepsCardProps}
 * @returns {<StepsCard />}
*/
const StepsCard = ({ color = colorDefault, text, icon = step1_svg_1.default, description }) => {
    const cardStyle = {
        backgroundColor: color,
    };
    return (react_1.default.createElement("div", { style: cardStyle, className: "card-style", "data-testid": "steps-card-element" },
        react_1.default.createElement("div", { className: description ? "steps-card-description" : "steps-card" },
            !description &&
                react_1.default.createElement("div", { className: "align-end steps-card-title-mobile" },
                    react_1.default.createElement("div", null, text)),
            react_1.default.createElement("div", { className: description ? "align-end" : "align-start" },
                react_1.default.createElement("img", { className: description ? "steps-icon-description" : "steps-icon", src: icon, alt: "" })),
            description &&
                react_1.default.createElement("div", { className: "align-start steps-texts-container-mobile" },
                    react_1.default.createElement("div", { className: "align-center steps-card-text-mobile" },
                        react_1.default.createElement("div", null, text)),
                    react_1.default.createElement("div", { className: "align-start steps-card-description-text" },
                        react_1.default.createElement("div", null, description))))));
};
exports.StepsCard = StepsCard;
//# sourceMappingURL=steps-card.js.map